export { default as NMenu, menuProps } from './src/Menu';
